import { render, staticRenderFns } from "./PRO_ByPatientTypePrintable.vue?vue&type=template&id=da3fee2e&scoped=true&"
import script from "./PRO_ByPatientTypePrintable.vue?vue&type=script&lang=js&"
export * from "./PRO_ByPatientTypePrintable.vue?vue&type=script&lang=js&"
import style0 from "./PRO_ByPatientTypePrintable.vue?vue&type=style&index=0&id=da3fee2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3fee2e",
  null
  
)

export default component.exports